import { createContext } from 'react';

import { ISelectSkeletonContext } from './SelectSkeleton.decl';

import noop from 'lodash-es/noop';

export const SelectSkeletonContext = createContext<ISelectSkeletonContext>({
  setSelected: noop,
  toggleMenu: noop,
  openMenu: noop,
  closeMenu: noop,
  onChange: noop,
  size: 'regular',
});
